var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    style: {
      cursor: "pointer"
    },
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 8.71942 0.508707 7.49129 1.41421 6.58579L6.58579 1.41421C7.36684 0.633165 8.63317 0.633166 9.41421 1.41421L9.58579 1.58579C10.3668 2.36684 10.3668 3.63316 9.58579 4.41421L6.17071 7.82929C6.10771 7.89229 6.15233 8 6.24142 8H22C23.1046 8 24 8.89543 24 10C24 11.1046 23.1046 12 22 12H6.24142C6.15233 12 6.10771 12.1077 6.17071 12.1707L9.58579 15.5858C10.3668 16.3668 10.3668 17.6332 9.58579 18.4142L9.41421 18.5858C8.63317 19.3668 7.36684 19.3668 6.58579 18.5858L1.41421 13.4142C0.508707 12.5087 0 11.2806 0 10Z",
    fill: "#F7A246"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.98a5da02de0299e7fe5a47875d889fc5.svg";
export { ForwardRef as ReactComponent };